import React from 'react'
import SubHeader from '../general/SubHeader';
import Mlm1 from '../assets/product/mlm1.webp';
import Mlm2 from '../assets/product/mlm2.webp';
import Mlm3 from '../assets/product/mlm3.png';

const MlmSoftware = () => {
  return (
    <>
      <SubHeader message='MLM Software' />

      <section className='my-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-8 col-12'>
              <img src={Mlm2} className='img-fluid' alt='Billing Software' />
              <p className='sec-heading'>Dectwin Multi Level Marketing Software</p>
              <p className='text-muted'>Our MLM software development company in Prayagraj simplifies and streamlines network marketing operations by providing Binary MLM software in Allahabad. It offers
                comprehensive tools for managing downlines, commissions, and payouts. It empowers businesses to efficiently track and grow their networks while ensuring
                transparency with industry standards.</p>

              <div className='bg-light rounded-3 px-3 py-3 my-3'>
                <p className='banner-subheading'>Windows/ Android Multi Level Marketing Software</p>
                <p className='text-muted'>We Dectwin Services, the leading MLM Software development company in Prayagraj provides a global MLM software development solution designed to manage and
                  streamline multi-level marketing operations. It offers advanced features like automated commission calculations, downline
                  management, product tracking, and reporting tools. The software also includes mobile application, allowing distributors to manage their accounts and monitor performance on the go, enhancing user engagement and overall business efficiency.</p>
              </div>

              <div className='bg-light rounded-3 px-3 py-3'>
                <p className='banner-subheading'>Features of Dectwin MLM Software</p>
                <p className='text-muted'><strong>Client Management</strong> MLM software’s client management feature allows businesses to track and manage distributor information, including personal details, performance data, and sales activity.<br /><br />
                  <strong>Product & Sale History Management</strong> The product and sale history management feature tracks all product sales, inventory, and transaction histories. It provides real-time insights into which products are performing best and helps in managing stock levels.<br /><br />
                  <strong>Milestone Rewards</strong> Milestone rewards allow businesses to set specific goals for distributors, rewarding them as they reach predefined milestones. By offering bonuses or points as rewards, businesses boost productivity and foster a competitive yet supportive environment within the network.<br /><br />
                  <strong>Chain Management</strong> It tracks the structure, performance, and growth of distributors within the downline, ensuring accurate commission calculations. This feature also helps identify top performers, assist struggling members, and maintain a balanced network for overall business success.<br /><br />
                  <strong>Automated Commission Calculation</strong> simplifies the payout process by calculating commissions based on the predefined compensation plan (binary, unilevel, etc.). It eliminates manual errors, ensuring accurate and timely payments to distributors. This feature saves time, reduces administrative workload, and ensures transparency in the commission structure, improving trust within the MLM network.</p>

              </div>

            </div>

            <div className='col-lg-4 col-12 my-2'>
              
                                                        <div className='bg-light px-3 py-4 rounded-3 mb-3'>
                                <p className='fw-bold fs-5'>Get Demo of MLM Software</p>
                                <button className='banner-btn1' onClick={() => window.open('https://wa.me/8707510135?text=Hey!%20Dectwin%20Services.%20I%20want%20demo%20of%20Dectwin%MLM%20Software.', '_blank')}>Schedule Free DEMO Now</button>
                                </div>
              <div className='bg-light px-3 py-4 rounded-3'>
                <p className='fw-bold fs-5'>Product Information</p>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-calculator"></i>
                  <div>
                    <p className='fw-semibold my-0'>Automated Commission Calculation</p>
                    <p className='para-text text-muted'>Calculate commissions based on predefined rules and compensation plans</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-network-wired"></i>
                  <div>
                    <p className='fw-semibold my-0'>Downline Management</p>
                    <p className='para-text text-muted'>Track and manage each distributor’s performance</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-gift"></i>
                  <div>
                    <p className='fw-semibold my-0'>Reward Distribution</p>
                    <p className='para-text text-muted'>Allocate points to distributors based on their sales or recruitment activities</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-chart-simple"></i>
                  <div>
                    <p className='fw-semibold my-0'>Report Analysis</p>
                    <p className='para-text text-muted'>Detailed reporting and analytics tools offer insights
                      into sales performance, downline growth, and commission structure</p>
                  </div>
                </div>

                <div className='contact-area mb-3'>
                  <i class="fa-solid contact-icon fa-globe"></i>
                  <div>
                    <p className='fw-semibold my-0'>Chain Management</p>
                    <p className='para-text text-muted'>Organize and manage the
                      hierarchical structure of your network</p>
                  </div>
                </div>

                <img src={Mlm1} className='img-fluid mt-3' alt='Billing Software' />
                <img src={Mlm3} className='img-fluid mt-3' alt='Billing Software' />
              </div>

            </div>
            {/* right ends */}

          </div>
          {/* row ends */}

        </div>
      </section>


      {/* Pricing Section */}
      <section className='my-5'>
        <div className='container text-center'>

          <div className='sec-heading text-capitalize'>Plans & Pricing</div>

          <div className='row mt-4 justify-content-center'>

            <div className='my-2 col-lg-4 col-md-6 col-12'>

              <div className='pricing-outer'>
                <div className='pricing-inner'>
  <h5 className='text-uppercase'>Basic Plan</h5>
  <div className='sec-heading'>₹ 4999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 7,999</span><br />
   Yearly AMC 3,999/-</h5>                </div>

                <div className='bg-light px-4 py-4 text-muted'>
                  <h6>Android, Desktop</h6>
                  <hr />
                  <h6>Manage Downline Chain</h6>
                  <hr />
                  <h6>Automated Commission Calculation</h6>
                  <hr />
                  <h6>Reward Points Distribution</h6>
                  <hr />
                  <h6>Milestone Rewards</h6>
                  <hr />
                  <h6>Sales History</h6>
                  <hr />
                  <h6>Mobile Application for Clients</h6>
                </div>

              </div>
              {/* pricing outer ends */}
            </div>
            {/* column ends */}

            <div className='my-2 col-lg-4 col-md-6 col-12'>

              <div className='pricing-outer'>
                <div className='pricing-inner'>
  <h5 className='text-uppercase'>Premium Plan</h5>
  <div className='sec-heading'>₹ 9999/- Year</div>
  <h5 className='mt-3'><span className='text-red'><i class="fa-solid fa-tags fa-flip-horizontal"></i> Sale</span> <span className='text-decoration-line-through'>₹ 15,999</span><br />
  Yearly AMC 3,999/-</h5>                </div>

                <div className='bg-light px-4 py-4 text-muted'>
                  <h6>Annual Software Maintenance</h6>
                  <hr />
                  <h6>Regular Updates</h6>
                  <hr />
                  <h6>1 Year Plan Recharge</h6>
                  <hr />
                  <h6>Technical Support</h6>
                  <hr />
                  <h6>Online Assistance</h6>
                  <hr />
                  <h6>Minor Customizations</h6>
                </div>

              </div>
              {/* pricing outer ends */}
            </div>
            {/* column ends */}

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Pricing Section ends */}
    </>
  )
}

export default MlmSoftware
